import React, {useEffect, useState} from 'react';
import Dropdown from '../Components/Common/Dropdown/Dropdown';
import {ContainerFlat} from './Styles'
import { eventEmiter } from '../rx/rxState';

const AttributeDropdown = (props) => {
  const [value, setValue ] = useState("");
  const [label, setLabel ] = useState("");
  
  useEffect(() =>{
    setValue(props.attribute.value);
    updateLabel(props.attribute.value);
  })

  const updateLabel = (value)=>{
    for(const option of props.attribute.options){
      if(option.value === value){
        setLabel( option.label );
        break;
      }
    }
  }

  const onClick = (value) => {
    let attr = props.attribute;
    props.onChange(attr.id, value.value);
    setValue(value.value);
    updateLabel(props.attribute.value);

    eventEmiter.next({
      type: 'update-view'
    })
  };

  return (
        <ContainerFlat>
          <div className='attribute-control'>
          <Dropdown
              name={props.attribute.displayName}
              initialValue={props.attribute.value}
              options={props.attribute.options}
              onChange={onClick}/>
          </div>
      </ContainerFlat>
  )
};

export default AttributeDropdown;
